import { render, staticRenderFns } from "./DynamicCollectionTabs.vue?vue&type=template&id=3efea526&"
import script from "./DynamicCollectionTabs.vue?vue&type=script&lang=js&"
export * from "./DynamicCollectionTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/buddy/magculture/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3efea526')) {
      api.createRecord('3efea526', component.options)
    } else {
      api.reload('3efea526', component.options)
    }
    module.hot.accept("./DynamicCollectionTabs.vue?vue&type=template&id=3efea526&", function () {
      api.rerender('3efea526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/DynamicTabs/DynamicCollectionTabs.vue"
export default component.exports